import { render } from "./SuperAdminHeader.vue?vue&type=template&id=490438ca"
import script from "./SuperAdminHeader.vue?vue&type=script&lang=js"
export * from "./SuperAdminHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__